import React from 'react'
import {useIntl} from "react-intl";
import {generatePath, useNavigate} from 'react-router-dom';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import icon from '../../../../common/assets/icons/link.svg';
import {pathnames as P} from '../../../../common/enums';
import styles from './ButtonLink.module.scss';

export type ButtonLinkProps = {
  id: string
}

const ButtonLink = ({id, ...rest}: ButtonLinkProps) => {
  const intl = useIntl();
  const tooltip = intl.formatMessage({
    id: 'invoiceOrders-tooltip-link',
    defaultMessage: 'Create a link for payment'
  });

  const navigate = useNavigate();

  const handleClick = async () => {
    const path = generatePath(P.PAYMENT_ID, {invoiceOrderID: id})
    navigate(path);
  };

  return (
    <ButtonAction
      variant={'icon'}
      icon={icon}
      onClick={handleClick}
      customClassnames={{container: styles.buttonContainer}}
      title={tooltip}
      {...rest}
    />
  );
};

export default ButtonLink;
